import React, { useRef } from 'react';
import { motion as m } from "motion/react"
import { pagesEnum } from './enums';
import { useState, useEffect } from "react";
import './App.css';
import supabase from './client';
import backgroundImage from './images/sprites/clouds.png';

import arrowImage from './images/symbols/arrow.png';
import pdf from "./types.s";
import contactPageImage from "./images/blackbird1.jpg";
import ScrollProgress from './scrollProgress';

var count = 0;

function openTab(link: string, newTabFlag: boolean) {
  if (newTabFlag) {
    window.open(
      link,
      '_blank'
    );
  } else {
    window.open(
      link,
      '_self'
    );
  }

}

// function download(file: string) {
//   const resumePDF = pdf(file);

//   //creating an invisible element
//   let element = document.createElement('a');
//   element.setAttribute('href',
//     resumePDF);
//   element.setAttribute('download', "Christopher_Powell_Resume");
//   document.body.appendChild(element);
//   element.click();
//   document.body.removeChild(element);
// }

function BlogPage() {
  // const [contentFlag, setFlag] = useState(1);
  const [jsonData, setData] = useState<any | null>();
  // const [visitorData, setVisitors] = useState<any | null>();
  // const [videoUrl, setVideoUrl] = useState<string>();
  // const [linkArray, setLinkArray] = useState<string[]>([]);
  // const [scrollY, setScrollY] = useState(0);
  // const [videoWasStarted, setVideoWasStarted] = useState(false);
  const videoWasStartedRef = useRef(false);
  const homeSection = useRef(null);
  const aboutSection = useRef(null);
  // const resumeSection = useRef(null);
  // const projectSection = useRef(null);
  const contactSection = useRef(null);
  const scrollProgress = useRef<HTMLDivElement>(null);

  const aboutVid1 = useRef<HTMLVideoElement>(null);

  // function vidStart(e: any) {
  //   // console.log(isScrolledIntoView(aboutVid1));
  //   // console.log(videoWasStartedRef);
  //   if (isScrolledIntoView(aboutVid1) && !videoWasStartedRef.current) {
  //     // alert("Video is playing now");
  //     setVideoWasStarted(true);
  //     videoWasStartedRef.current = true;
  //     aboutVid1.current?.play();
  //   }

  // }

  useEffect(() => {

    const queryServer = async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('*').order('displayOrder', { ascending: true });

      if (error) {
        //console.log("We had a query error");
      }

      if (data) {
        setData(data)
        // alert(data.statusText as string)
        // //console.log(data)
      }
    }

    queryServer();

    // const handleScroll = () => {
    //   setScrollY(window.scrollY);
    // };

    var timer: string | number | NodeJS.Timeout | null | undefined = null;
    window.addEventListener('scroll', function () {
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        if (scrollProgress.current) {
          scrollProgress.current.style.backgroundColor = "";
        }
      }, 150);
    }, false);

    window.addEventListener('scroll', scrollProgressGlow);


    // Cleanup the listener on component unmount
    return () => {
      // window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function scrollProgressGlow() {
    if (scrollProgress?.current) {
      scrollProgress.current.style.backgroundColor = "red";
      scrollProgress.current.style.mask = "linear-gradient(0deg,transparent,90%,blue,100%)"

    }
  }

  // var data = require('./projectFile.json') as JSON;
  async function logVisit() {
    const { error } = await supabase
      .from('visitors')
      .insert({ id: count })
    count += 1;
  }

  // const rootElement = document.getElementById("mainPage");
  // var root;
  // if (rootElement) {
  //   root = createRoot(rootElement);
  // }

  function cloudBank() {
    return (
      <div className="cloudBank" style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
        <img src={backgroundImage}></img>
      </div>
    )
  }


  function randomSplashVideo() {
    // if(linkArray.length == 0){
    //   alert("No more backgrounds");
    // }
    var tempArray = ["/videos/compressed/shuttle.mp4", "/videos/compressed/shuttle2.mp4", "videos/compressed/interstage.mp4", "videos/compressed/starship1.mp4", "videos/compressed/iss1.mp4", "videos/compressed/iss2.mp4", "videos/compressed/iss3.mp4"];
    var num = Math.floor(Math.random() * tempArray.length);
    var link = tempArray[num];
    // tempArray.splice(num,1);
    // setLinkArray(tempArray);
    //console.log("ARRAY:" + num.toString());
    return link;
  }

  function deterministicSplashVideo() {
    var tempArray = [["videos/compressed/iss2.mp4", 0],
    ["/videos/compressed/shuttle.mp4", 55],
    ["/videos/compressed/shuttle2.mp4", 0],
    ["videos/compressed/interstage.mp4", 2],
    ["videos/compressed/starship1.mp4", 0],
    ["videos/compressed/iss1.mp4", 0]];
    return (tempArray);
  }

  function handleMetaData(event: React.SyntheticEvent<HTMLVideoElement, Event>, time: number) {
    const videoElement = event.target as HTMLVideoElement;
    videoElement.currentTime = time;
  }

  // function advanceVideo() {
  //   setVideoUrl(randomSplashVideo());
  // }

  function copyToClipboard(text: string) {
    // Get the text
    var copyText = text;

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText);
    // Alert the copied text
    // alert("Copied to Clipboard");

  }

  function scrollToSection(section: any) {
    section.current?.scrollIntoView({ behavior: "smooth" });
  };


  function isScrolledIntoView(vidRef: React.RefObject<HTMLVideoElement | null>) {
    var elemTop = vidRef.current?.getBoundingClientRect().top;
    var elemBottom = vidRef.current?.getBoundingClientRect().bottom;

    var isVisible = (elemTop ?? 0 >= 0) && (elemBottom ?? 0 <= window.innerHeight);
    return isVisible;
  }

  var blogContent = [{
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }, {
    title: "Test title",
    date: "7/2/2025",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque cursus ex ut accumsan laoreet. In laoreet lorem vel nunc facilisis, ut tempor lorem placerat. Nam imperdiet sagittis tempus. Aenean gravida est vel leo auctor commodo. Sed tempor lacus erat, pellentesque feugiat nisi hendrerit eu. Fusce aliquam lacinia semper. Mauris nisi felis, ullamcorper nec est pretium, mattis laoreet ex. Vivamus ut vehicula tellus, non efficitur lacus. Pellentesque diam orci, finibus sit amet aliquam a, suscipit ac mauris. Quisque ut cursus sapien. Suspendisse ex leo, maximus tincidunt fermentum eu, dapibus vitae massa. Quisque lacinia magna quis sapien ultricies vulputate. Cras condimentum eu mi et feugiat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas eu dolor vel lacus sagittis accumsan. Cras eleifend dui et odio lacinia, at pretium enim finibus. Vivamus et tortor mi. Nullam aliquet molestie imperdiet. Sed egestas ultrices magna, malesuada consequat tortor venenatis eget."
  }]

  return (
    <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, ease: "easeOut" }}>
      <div id="mainPage" className="App">
        <ScrollProgress ref={scrollProgress}></ScrollProgress>
        <div className="landingOverlay" style={{
          position: "fixed", top: "20%", flexDirection: "column", margin: 0, height: "max-content", maxHeight: "100%", gap: 20,
          overflow: "auto", boxSizing: "border-box", alignSelf: "flex-end", padding: 20
        }}>
          <button style={{ minWidth: "15vw" }} onClick={() => openTab(pagesEnum.home, false)}>go home<img style={{ maxWidth: 50, maxHeight: "auto", transform: "rotate(-45deg)" }} src={arrowImage}></img></button>
        </div>


        <div ref={homeSection} className="landing">
          <div className="landingOverlay">
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", flexWrap: "wrap", width: "100%" }}>
              <h1>blog</h1>
            </div>
          </div>

          <div className="landingBackground">
            {/* <img src={concordeCropped}></img> */}
            <video className="vid" autoPlay playsInline muted loop controls={false}>
              <source src={deterministicSplashVideo()[1][0] as string} />
            </video>
          </div>
        </div>


        <div className="aboutPage">
          {/* <img src={concorde}></img> */}
          <div className="aboutPageBackground">
            {
              deterministicSplashVideo().map((data) => (
                <video className="vid" onLoadedMetadata={(e) => handleMetaData(e, data[1] as number)} autoPlay muted loop controls={false}>
                  <source src={data[0] as string} />
                </video>
                // <img style={{backgroundColor:"black"}} src={data}></img>

              ))
            }
          </div>
          <h1 ref={aboutSection} className="bodyContentHeader"> feed</h1>
          <div className="aboutPageContent">
            {/* Bundle #1 */}
            {
              blogContent.map((data) => (
                <div style={{ minHeight: "70vmax" }} className="aboutPageContentBundle">
                  <div className="innerBundle">
                    <div style={{ gap: "10rem", justifyContent: "space-between" }} className="genericRow"><h2>{data.title.toLowerCase()}</h2><h2 style={{ fontFamily: "monospace" }}>{data.date.toLowerCase()}</h2></div>
                    <p style={{ fontFamily: "monospace", textAlign: "left" }}>{data.content}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        <div className="mainContent">
          {/* <MainNavigation></MainNavigation> */}

          {/* <div style={{ backgroundColor: "#0487E2" }} className="cloudScroll">
            <div className="cloudScrollInner">
              {cloudBank()}
              {cloudBank()}
            </div>
          </div>


          <h1 ref={projectSection} className="sectionHeader">recent projects</h1>
          <div id="projectGrid" className="projectGrid">
            {
              jsonData?.map((data: { imgPath: any; text: any; title: any; url: any; externalResource: any; subtitle: any; }, i: any) => (
                <Projects imgPath={data.imgPath} text={data.text} title={data.title} url={data.url} externalResource={data.externalResource}
                  subtitle={data.subtitle} key={i} info={data}></Projects>
              ))
            }

          </div> */}


          <div ref={contactSection} className="contactPage">
            <div className="contactPageBackground">
              <img src={contactPageImage}></img>
            </div>

            <div className="contactPageContent">
              <h1>contact me</h1>
              <a href="mailto:cspowell5438@gmail.com"><p>cspowell5438@gmail.com</p></a>
              <button className="taxiwayButton" onClick={() => copyToClipboard("cspowell5438@gmail.com")}>copy to clipboard</button>
            </div>
          </div>
        </div>
      </div>
    </m.div>
  );
}
export default BlogPage;
